module.exports = __webpack_public_path__ + "img/1_1_document_type.9688804d.gif";